import { TimePlanningBalance, TimePlanningBalancesByPeriod } from 'generated/resources/graphql'

// TODO: This file will be removed once we enable dev_time_planning_balances_in_shifts
// eslint-disable-next-line factorial/no-allowed-mobx-collections
import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import EmployeeCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/EmployeeCell'
import WorkAreaCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/WorkAreaCell'
import type { ShiftsRow, View } from 'modules/shift_management/lib/types'
import { GROUP_TYPES } from 'modules/shift_management/store/internal/models/View'

interface Props {
  view: View
  shiftsRow: ShiftsRow
  contractVersions: ContractVersions
  balances?: TimePlanningBalance
  periodBalances?: TimePlanningBalancesByPeriod[]
}

export const FirstCell = ({
  view,
  shiftsRow,
  contractVersions,
  balances,
  periodBalances,
}: Props) => {
  switch (view.groupType) {
    case GROUP_TYPES.areas:
      return <WorkAreaCell shiftsRow={shiftsRow} />

    default:
      return (
        <EmployeeCell
          shiftsRow={shiftsRow}
          contractVersions={contractVersions}
          balances={balances}
          periodBalances={periodBalances}
        />
      )
  }
}
